export default ($) => {
	primoSearch();
	
	function primoSearch() {
		let primoForm = document.getElementById('primoSearchForm');
		let primoSubmitBtn = document.getElementById('go');
		
		if(typeof primoForm !== 'undefined' && primoForm !== null) {
			primoForm.addEventListener('submit', function(e){
				e.preventDefault();
				doSearchPrimo();
			});
			
			primoSubmitBtn.addEventListener('click', function(e){
				e.preventDefault();
				doSearchPrimo();
			});
			
			primoSubmitBtn.addEventListener('keydown', function(e){
				e.preventDefault();
				if (e.keyCode === 13) {
					doSearchPrimo();
				}
			});
		}
	}
	
	function doSearchPrimo() {
		document.getElementById('primoQuery').value = 'any,contains,' + document.getElementById('primoQueryTemp').value.replace(/[,]/g, ' ');
	
		let dropdownValue = document.getElementById('primoScope').value;
		let tabValue;
		switch (dropdownValue){
			case 'MyInst_and_CI':
				tabValue = 'Everything';
				break;
			case 'MyInstitution':
				tabValue = 'LibraryCatalog';
				break;
			case 'CentralIndex':
				tabValue = 'CentralIndex';
				break;
			case 'CourseReserves':
				tabValue = 'CourseReserves';
				break;
			default:
				tabValue = dropdownValue;
				break;
		}
		document.getElementById('primoTab').value = tabValue;
		document.forms['primoSearchForm'].submit();
	}
}